<p-step-list class="custom-step-list">
  @for (step of steps; track step.value) {
    <p-step
      [value]="step.value"
      class="custom-step">

      <ng-template
        #content
        let-activateCallback="activateCallback"
        let-value="value">

        <button
          type="button"
          class="step-button"
          [class.disabled]="step.disabled"
          [disabled]="step.disabled"
          (click)="onStepClick(step.value)">

          <span
            class="step-icon"
            [class.active]="isStepActive(step.value)"
            [class.current]="value === activeStep">

            <span class="material-symbols-rounded">
              {{ step.iconName }}
            </span>
          </span>

          <span class="step-label">
            {{ step.isTranslated ? (step.label | translate) : step.label }}
          </span>
        </button>

      </ng-template>
    </p-step>
  }
</p-step-list>
